import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    products: [],
    selectedProduct: null,
    pagination: {
        page: 1,
        limit: 24,
        total: 0,
        totalPages: 0,
    },
    isLoading: false
};

const productSlice = createSlice({
    name: "product",
    initialState,
    reducers: {
        setProducts: (state, action) => {
            state.products = action.payload.products;
            state.pagination = action.payload.pagination || null;
        },
        setSelectedProduct: (state, action) => {
            state.selectedProduct = action.payload;
        },
        clearSelectedProduct: (state) => {
            state.selectedProduct = null;
        },
        addProduct: (state, action) => {
            state.products.unshift(action.payload);
        },
        updateProduct: (state, action) => {
            const index = state.products.findIndex(
                p => p._id === action.payload._id
            );
            if (index !== -1) {
                state.products[index] = action.payload;
            }
            if (
                state.selectedProduct &&
                state.selectedProduct._id === action.payload._id
            ) {
                state.selectedProduct = action.payload;
            }
        },
        removeProduct: (state, action) => {
            state.products = state.products.filter(
                p => p._id !== action.payload
            );
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        }
    }
});

export const {
    setProducts,
    setSelectedProduct,
    clearSelectedProduct,
    addProduct,
    updateProduct,
    removeProduct,
    setLoading
} = productSlice.actions;

export const ProductReducer = productSlice.reducer;
